module.exports = __webpack_public_path__ + "img/PL00249.c14a01e4.png";